import { useDispatch, useSelector } from 'utils/hooks'
// ? redux
import { lastConfirmedPayroll } from 'redux/authUser/actionCreators'
import { loadSecurityPolicies } from 'redux/setting/security/actionCreators'
import { banksLoad, nationalitiesLoad } from 'redux/actions/staticRecordActions'
import { subscribeFirebase } from 'redux/actions/firebaseActions'
import { checkSetupIsDoneLoad } from 'redux/payroll/glMapping/glSetup/actionsCreator'
import { getEnablerData } from 'redux/setting/integration/IntegrationEnablers/actionCreators'
import { employeeNotificationsSettingLoad } from 'redux/appNotifications/NotificationsSetting/actionCreators'

import { initFirebase } from 'firebaseUtils'
import { ORGANISATION_NAME, serverEnvironment } from 'env'
import { initMixpanel } from 'utils/mixpanel'
import { payrunActivationStatus } from 'redux/payroll/payrun/actionsCreator'
import { getSwitchableOrgs } from 'redux/setting/orgSubsidiaries/SwitchableOrgs/actionCreators'

type UseNavigationType = {
  initializeAppCalls: () => Promise<void>
}

const useMainNavigation = (): UseNavigationType => {
  const dispatch = useDispatch()
  const current_user = useSelector((s) => s.auth.employee)
  const notificationsSettings = useSelector(
    (s) => s.notificationsSetting.employee_configuration?.options,
  )

  const initializeFirebase = async (): Promise<void> => {
    const env = serverEnvironment === 'maken' ? 'makenhr' : serverEnvironment
    const onToken = (token: string): void => {
      const userId = current_user?.id
      const {
        assign_shifts,
        publish_shifts,
        bulk_update_employee_information,
        manage_other_financial_information,
        edit_on_payroll_table,
        view_payroll_table,
      } = current_user?.permission_details || {}

      const topics = [
        ...(notificationsSettings?.announcements === 'true'
          ? [`${env}_jisr_announcements_${ORGANISATION_NAME}`]
          : []),
        ...(notificationsSettings?.announcements === 'true'
          ? [`${env}_jisr_announcements_${userId}`]
          : []),
        ...(notificationsSettings?.requests_and_tasks === 'true'
          ? [`${env}_jisr_${userId}_employee`]
          : []),
        ...(notificationsSettings?.updates === 'true'
          ? [`${env}_jisr_updates_${ORGANISATION_NAME}`]
          : []),
        ...(view_payroll_table ? [`${env}_jisr_${ORGANISATION_NAME}_payrun`] : []),
        ...(!!assign_shifts || !!publish_shifts
          ? [`${env}_jisr_${userId}_bulk_import_scheduler`]
          : []),
        ...(!!bulk_update_employee_information && !!manage_other_financial_information
          ? [
              `${env}_jisr_${userId}_bulk_import_payroll_startup_payment_details`,
              `${env}_jisr_${userId}_bulk_import_wps_gosi_infos`,
            ]
          : []),
        ...(edit_on_payroll_table ? [`${env}_jisr_${userId}_bulk_import_payroll_adjustments`] : []),
      ]
      const payload = {
        token,
        topics,
      }
      dispatch(subscribeFirebase(payload))
    }

    initFirebase(onToken)
  }

  const initializeAppCalls = async (): Promise<void> => {
    const manage_integrations = current_user?.permission_details?.manage_integrations
    const employeeId = current_user?.id

    dispatch(banksLoad())
    dispatch(nationalitiesLoad())
    dispatch(lastConfirmedPayroll())
    await dispatch(payrunActivationStatus())
    dispatch(loadSecurityPolicies({ template: 'public' }))
    dispatch(getEnablerData())
    dispatch(getSwitchableOrgs())
    if (manage_integrations) dispatch(checkSetupIsDoneLoad())

    await dispatch(employeeNotificationsSettingLoad(Number(employeeId)))
    initializeFirebase()
    initMixpanel()
  }

  return {
    initializeAppCalls,
  }
}

export default useMainNavigation
